<script>
    import {Listeners} from "../../../constants/listeners";
    import AdaptersDialog from "../../../component/adapters/Dialog.vue";
    import AdaptersDropdown from "../../../component/adapters/Dropdown.vue";
    import UserApi from "../../../api/UserApi";
    import GroupReportApi from "../../../api/GroupReportApi";
    import Alerts from "../../../mixins/Alerts";

    export default {
        mixins: [Alerts],
        data () {
            return {
                name: 'GroupChangeReportOwner',
                loading: false,
                error: null,
                currentReportData: {},
                colleagues: [],
                model: ""
            }
        },
        mounted() {
            this.$emitter.on(Listeners.KS_CHANGE_OWNER_REPORT, eventData => this.onChangeOwner(eventData));
        },
        methods: {
            onChangeOwner(data) {
                this.currentReportData = data;
                this.onOpen();
            },

            loadColleague(){
                this.loading = true;
                UserApi
                    .getCorporateColleagues()
                    .then(response => this.colleagues = response)
                    .catch(error => this.alertError(error.message))
                    .finally(() => this.loading = false);
            },

            changeOwner() {
                this.error = null;
                if (!this.model) {
                    this.error = this.$t('lang.corp_users.own_clg_err');
                    return false;
                }

                this.loading = true;
                GroupReportApi
                    .changeReportOwner(this.currentReportData.rid, {user: this.model})
                    .then(() => {
                        this.onClose();
                        this.$emitter.emit(Listeners.KS_FILTER_REFRESH);
                        this.$emitter.emit(Listeners.RELOAD_GROUP_REPORTS_LIST);
                    })
                    .catch(error => this.alertError(error.message))
                    .finally(() => this.loading = false);
            },
            onClose() {
                this.error = null;
                this.model = "";
                this.$emitter.emit(this.getListenerCloseId);
            },
            onOpen() {
                this.loadColleague();
                this.$emitter.emit(this.getListenerId);
            }

        },
        computed: {
            getListenerId() {
                return Listeners.KS_POPUP_CHANGE_OWNER_REPORT_OPEN;
            },
            getListenerCloseId() {
                return Listeners.KS_POPUP_CHANGE_OWNER_REPORT_CLOSE;
            },
        },
        components: {
            AdaptersDropdown,
            AdaptersDialog,
        }
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="getListenerId"
        :listener-close-id="getListenerCloseId"
        :header="$t('lang.corp_users.change_owner')"
        :loading="loading"
        :error-message="error"
        :callback-agree="changeOwner"
        :callback-on-hide="onClose"
        :button-agree-label="$t('lang.main.btn.appoint')"
    >
        <template #content>
            <AdaptersDropdown
                v-model="model"
                :options="colleagues"
                option-value="email"
                option-label="email"
                :placeholder="$t('lang.corp_users.select_user')"
                class="w-full"
            />
        </template>
    </AdaptersDialog>
</template>
